import { createRouter, createWebHistory } from 'vue-router';
import { routes } from './routes';
import Authentication from '@/plugins/authentication';

const router = createRouter({
    history: createWebHistory(),
    routes,
});

router.beforeEach((to, _from, next) => {
    const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
    const isAuthenticated = Authentication.isAuthenticated();

    if (requiresAuth && !isAuthenticated) {
        Authentication.redirectToLoginPage();
        next(false);
    } else {
        next();
    }
});

export default router;
